import { JSX } from 'react';
import { useEffect } from 'react';
import { isExcludedRoute } from './excluded-routes';
import { usePath } from '../../navigation/use-path';
import { trpc } from '../../trpc';
import { useAuth } from './auth.hook';

type GuardProps = {
  children: JSX.Element;
};

export const Guard = ({ children }: GuardProps) => {
  const { path } = usePath();
  const { data: user } = trpc.auth.getCurrentUser.useQuery();
  const { isAuthenticated, setAuthenticated } = useAuth();

  useEffect(() => {
    setAuthenticated(!!user);
  }, [user]);

  return (
    <>
      {isExcludedRoute(path) ? children : isAuthenticated && children}
    </>
  );
};
